var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1106,
    viewBox: "0 0 1920 1106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdi_87_36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1106,
    fill: "#FFCF00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M526 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M650 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M774 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M898 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1022 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1270 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1394 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1518 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1642 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1766 0L1766 1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1890 0V1106",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 115L-0.499952 115",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 239.001L-0.499952 239.001",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 363.001L-0.499952 363.002",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 487.002L-0.499952 487.002",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 611.003L-0.499952 611.003",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 735.003L-0.499952 735.004",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 859.004L-0.499952 859.004",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 983.004L-0.499952 983.005",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 1107.01L-0.499952 1107.01",
    stroke: "#FAB908",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_87_36",
    x: -6,
    y: -11,
    width: 1934,
    height: 1121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_87_36"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.137255 0 0 0 0 1 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_87_36",
    result: "effect2_dropShadow_87_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_87_36",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_87_36"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBg01);
export default __webpack_public_path__ + "static/media/img_bg_01.e2eee30b5c5a7e6a22fc8327d11faf1b.svg";
export { ForwardRef as ReactComponent };